module.exports = __webpack_public_path__ + "fonts/NotoSansEthiopic-Regular.b6d2fc04.ttf";